// extracted by mini-css-extract-plugin
module.exports = {"mainParagraph":"style_mainParagraph__nC3ZO","mainContainer":"style_mainContainer__WObKS"};